import { Box, Button, FormikField as Field, Input } from '@betterment/samba-react';
import { WorkflowLayout } from '@betterment/shared-components';
import { Form, Formik } from 'formik';
import { useNavigate, useSearchParams } from 'react-router-dom';
import * as Yup from 'yup';

import { nameAndImage } from './sharedSchemas';

type Props = {
  initialValues: FormValues;
  handleSubmit: (values: FormValues) => void;
};

type FormValues = Yup.InferType<typeof nameAndImage>;

export const NameAndImage: React.FC<Props> = ({ handleSubmit, initialValues }) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const returnTo = searchParams.get('returnTo');

  return (
    <WorkflowLayout pageTitle={null}>
      <WorkflowLayout.Header
        workflowTitle="Choose a name and image for this goal"
        onClose={() => (returnTo ? navigate(returnTo) : navigate('/'))}
      />
      <WorkflowLayout.Content>
        <Formik
          onSubmit={handleSubmit}
          initialValues={initialValues}
          validationSchema={nameAndImage}
          validateOnChange={false}
          validateOnBlur={false}
          enableReinitialize={true}
        >
          <Form>
            <Box css={{ display: 'grid', gap: 'space.200', maxWidth: '400px' }}>
              <Field name="name">
                <Field.Label>Goal name</Field.Label>
                <Field.Control>
                  <Input />
                </Field.Control>
                <Field.ErrorMessage />
              </Field>

              <Button type="submit" variant="solidPrimary" css={{ width: 'fit-content' }}>
                Continue
              </Button>
            </Box>
          </Form>
        </Formik>
      </WorkflowLayout.Content>
    </WorkflowLayout>
  );
};
